import { DatePipe, DecimalPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { FreelancerRequestService } from '../../freelancer-requests/freelancer-request.service';
import { FreelancerRequestsFilterService } from '../../freelancer-requests/freelancer-requests-filter.service';
import { FreelancerRequestDetailService } from '../freelancer-request-detail.service';

@Component({
    selector: 'app-freelancer-request-detail-header',
    templateUrl: './request-detail-header.component.html',
    standalone: true,
    imports: [
        NgIf,
        ButtonDirective,
        TooltipModule,
        DatePipe,
        TranslateModule,
        DecimalPipe
    ]
})
export class FreelancerRequestDetailHeaderComponent {

    get translatedStatus(): string {
        let invariantStatus = "STATUS.";

        if (this.freelancerRequestDetailService.request.personQuery.isDocumentsDowloadCompleted
            && !this.freelancerRequestDetailService.feasibilityData.isCreditOperationMade
        ) {
            invariantStatus += 'Pending_feasibility';
        } else {
            invariantStatus += this.freelancerRequestDetailService.request.personQuery.status;
        }

        return this.translateService.instant(invariantStatus);
    }

    get feasibilityResult(): number {
        return this.freelancerRequestDetailService.feasibilityData.creditAmount;
    }

    constructor(
        public readonly freelancerRequestDetailService: FreelancerRequestDetailService,
        public readonly freelancerRequestsFilterService: FreelancerRequestsFilterService,
        public readonly freelancerRequestService: FreelancerRequestService,
        private readonly router: Router,
        private readonly translateService: TranslateService
    ) { }

    navigateToRequests(): void {
        this.router.navigate(['/freelancers']).catch(error => { console.error(error); });
    }
}
